import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import {
  Switch, Route, Redirect, withRouter,
} from 'react-router-dom';
import pages from './pages';
import { isSSR, smoothScroll, responsive } from '../../helpers/view';
import Error from '../../components/Error';

class HelpContainer extends React.PureComponent {
  UNSAFE_componentWillMount() {
    if (isSSR()) {
      if (!this.pageExists()) {
        this.props.staticContext.page.status = 404;
      }
    }
  }

  componentDidMount() {
    smoothScroll();
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.location.pathname !== this.props.location.pathname)
      && (
        responsive.isMobileOrTablet()
        || (!responsive.isMobileOrTablet() && prevProps.location.pathname !== '/shop/help')
      )
    ) {
      smoothScroll();
    }
  }

  pageExists = () => {
    return pages.find((page) => `/shop/help${page.path}` === this.props.location.pathname);
  };

  render() {
    if (!this.pageExists()) {
      return <Error errorCode="404" />;
    }

    return (
      <Fragment>
        <Helmet defer>
          <title>Help at Mp3Caprice</title>
          {
            this.props.location.pathname === '/shop/help' && <meta property="mc:dp" content="/shop/help" />
          }
          <meta property="mc:page" content="Help" />
        </Helmet>
        <Switch>
          {
            pages.map((page) => {
              if (page.to) {
                return <Redirect key={page.path} path={`/shop/help${page.path}`} to={`/shop/help${page.to}`} />;
              }

              return (
                <Route
                  key={page.path}
                  path={`/shop/help${page.path}`}
                  render={page.render || (() => page.routeComponent)}
                  exact
                />
              );
            })
          }
        </Switch>
      </Fragment>
    );
  }
}

export default withRouter(HelpContainer);
